import Button from "@/component/Button";
import summaryCommonStore from "@/store/summaryCommon.store";
import Checkbox from "@/component/Checkbox";
import { useState } from "react";
import { IDetailInfo } from "@/types/summary";
import { isMac } from "@/utils/platform";
import fridayReporter from "@/utils/friday";
import { Origin } from "@/constants/share";
import { ExportType, exportTypeNameMap } from "@/constants/record";
import useExport from "@/sections/Summary/useExport";

interface ExportPopoverProps {
  detailInfo: IDetailInfo | null;
  generatedTitle: string;
}

const ExportPopover = (props: ExportPopoverProps) => {
  const { detailInfo, generatedTitle } = props;
  const { summaryDone, srcDone, audioDone, speechDraftDone } = useExport();
  const downloadSrcDoc = summaryCommonStore((state) => state.downloadSrcDoc);
  const downloadSummary = summaryCommonStore((state) => state.downloadSummary);
  const downloadAudio = summaryCommonStore((state) => state.downloadAudio);
  const downloadSpeechDraft = summaryCommonStore((state) => state.downloadSpeechDraft);
  const shareInfo = summaryCommonStore((state) => state.shareInfo);
  const [exportSrcDoc, setExportSrcDoc] = useState(!isMac());
  const [exportSummary, setExportSummary] = useState(true);
  const [exportAudio, setExportAudio] = useState(false);
  const [exportSpeechDraft, setExportSpeechDraft] = useState(false);

  // mac端临时变成单选吧，这里写的不好看，后面肯定得改的，现在他们急着出版本
  // 而且在Electron采用a标签下载不妥，如一点进度都无，后续肯定得改，在主进程提供下载能力
  const handleChoose = (type: ExportType, value: boolean) => {
    switch (type) {
      case ExportType.exportSrcDoc:
        setExportSrcDoc(value);
        if (isMac() && value) {
          setExportAudio(false);
          setExportSummary(false);
          setExportSpeechDraft(false);
        }
        break;
      case ExportType.exportSummary:
        setExportSummary(value);
        if (isMac() && value) {
          setExportAudio(false);
          setExportSrcDoc(false);
          setExportSpeechDraft(false);
        }
        break;
      case ExportType.exportAudio:
        setExportAudio(value);
        if (isMac() && value) {
          setExportSrcDoc(false);
          setExportSummary(false);
          setExportSpeechDraft(false);
        }
        break;
      case ExportType.exportSpeechDraft:
        setExportSpeechDraft(value);
        if (isMac() && value) {
          setExportSrcDoc(false);
          setExportSummary(false);
          setExportAudio(false);
        }
        break;
    }
  };

  const handleDownload = async () => {
    const fileName = generatedTitle || detailInfo?.title || "";
    const useComplete = shareInfo?.origin === Origin.MEETING_PLATE && shareInfo?.fileTransEnable;
    const contentStep = useComplete ? 'COMPLETE_DOC' : 'SRC_DOC';
    const fileTypeArr = [];
    if (exportSrcDoc) {
      await downloadSrcDoc(fileName, contentStep)
      fileTypeArr.push('原文')
    }
    if (exportSummary) {
      await downloadSummary(fileName, contentStep)
      fileTypeArr.push('智能总结')
    }
    if (exportAudio) {
      await downloadAudio(fileName)
      fileTypeArr.push('音频')
    }
    if (exportSpeechDraft) {
      await downloadSpeechDraft(fileName)
      fileTypeArr.push('发言稿')
    }

    fridayReporter.pushData({
      eventCode: 'SummaryPage_Export_Local',
      payload: {
        file_type: fileTypeArr.join('、')
      }
    })
  };

  return (
    <div className="w-46 bg-white p-2">
      <div className="text-mx-tertiary text-3 mb-4.5">导出</div>
      <div className="flex flex-col gap-4 mb-6">
        {srcDone && <Checkbox
          checked={exportSrcDoc}
          onChange={(e) => {
            handleChoose(ExportType.exportSrcDoc, e.target.checked);
          }}
        >
          {exportTypeNameMap[ExportType.exportSrcDoc]}
        </Checkbox>}
        {summaryDone && <Checkbox
          checked={exportSummary}
          onChange={(e) => {
            handleChoose(ExportType.exportSummary, e.target.checked);
          }}
        >
          {exportTypeNameMap[ExportType.exportSummary]}
        </Checkbox>}
        {audioDone && <Checkbox
          checked={exportAudio}
          onChange={(e) => {
            handleChoose(ExportType.exportAudio, e.target.checked);
          }}
        >
          {exportTypeNameMap[ExportType.exportAudio]}
        </Checkbox>}
        {speechDraftDone && <Checkbox
          checked={exportSpeechDraft}
          onChange={(e) => {
            handleChoose(ExportType.exportSpeechDraft, e.target.checked);
          }}
        >
          {exportTypeNameMap[ExportType.exportSpeechDraft]}
        </Checkbox>}
      </div>
      <Button className="lh-7 text-mx-secondary" onClick={handleDownload}>
        导出到本地
      </Button>
    </div>
  );
};

export default ExportPopover;
